module.exports = __webpack_public_path__ + "img/1556137924.370fe82d.jpg";